"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importDefault(require("react"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var styles_1 = require("./styles");
var Pagination = function (_a) {
    var id = _a.id, totalRecords = _a.totalRecords, currentPage = _a.currentPage, recordsPerPage = _a.recordsPerPage, onClickPrev = _a.onClickPrev, onClickNext = _a.onClickNext;
    if (currentPage > 0 && recordsPerPage > 0 && totalRecords > 0) {
        var pageMinLimit = (currentPage - 1) * recordsPerPage + 1;
        var pageMaxLimit = Math.min(pageMinLimit + recordsPerPage - 1, totalRecords);
        var disabledPrev = pageMinLimit === 1;
        var disabledNext = pageMaxLimit === totalRecords;
        return (react_1.default.createElement(styles_1.PaginationSectionStyled, { id: id },
            react_1.default.createElement(paragraphy_styles_1.PStyled, { "data-testid": "range-records", p14: true, bold: true },
                pageMinLimit,
                " - ",
                pageMaxLimit),
            react_1.default.createElement(paragraphy_styles_1.PStyled, { p14: true }, "\u00A0de\u00A0"),
            react_1.default.createElement(paragraphy_styles_1.PStyled, { "data-testid": "total-records", p14: true, bold: true }, totalRecords),
            react_1.default.createElement(styles_1.PaginationButtonStyled, { "data-testid": "prev-button", onClick: onClickPrev, disabled: disabledPrev },
                react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.ChevronLeft, size: "md" })),
            react_1.default.createElement(styles_1.PaginationButtonStyled, { "data-testid": "next-button", onClick: onClickNext, disabled: disabledNext },
                react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.ChevronRight, size: "md" }))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.Pagination = Pagination;
